<template>
  <div class="basic-layout d-flex align-items-center justify-content-center m-0 default-body">
    <child />
    <notifications />
  </div>
</template>

<script>
import Child from '@/components/Child';
import Notifications from '~/components/Notifications';


export default {
  name: 'AuthLayout',

  components: {
    Child,
    Notifications,
  },
  mounted() {
    // Add a response interceptor
    window.axios.interceptors.response.use((response) => {
      if (!!response.data.type && !!response.data.message) {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
      }
      return response;
    }, (error) => {
      let errores = '';
      if (error.response.data.errors) {
        // Request made and server responded
        const errors = Object.values(error.response.data.errors);
        errors.forEach((element) => {
          errores += element;
        });
      } else if (error.request) {
        // The request was made but no response was received
        errores = 'Ocurrió un error en la comunicación con el servidor.';
      } else {
        // Something happened in setting up the request that triggered an Error
        errores = 'Ocurrió un error en la comunicación con el servidor.';
      }
      this.$store.dispatch('notifications/show', {
        message: errores,
        type: 'error',
      });
      return Promise.reject(error);
    });
  },
};
</script>
<style lang="scss">
@import "../../public/sass/app.scss";
</style>
<style scoped>
.default-body{
  background: -webkit-gradient(linear, left top, right bottom, from(#0084CA), to(#74D1EA)) !important;
  overflow: hidden;
}
</style>
